import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/**
 * Where a team that has run out goes. Shared by every Deep Dive surface that
 * can start a paid run -- the tool shelf and both report pages -- so a run
 * cannot be started from one of them while the others are blocked.
 */
const BuyCreditsLink: React.FC<{ primary?: boolean }> = ({ primary }) => (
  <Link
    className={`entity-hub-btn${primary ? ' primary' : ''}`}
    to={{ pathname: '/profile', state: { linkTab: 'Subscriptions' } }}
  >
    Buy credits
    <ArrowForwardIcon />
  </Link>
);

export default BuyCreditsLink;
